import { useObserver } from "mobx-react";

export default function ScoreCard({ title, description, percentage }) {
  return useObserver(() => (
    <div className="bg-black text-white rounded-xl p-4 md:p-10 md:px-12 flex items-center space-x-4 md:space-x-8 w-full  mx-auto ">
      {/* Circular Progress Indicator */}
      <div className="relative w-16 h-16 md:w-20 md:h-20 flex items-center justify-center">
        <svg
          className="w-full h-full transform -rotate-90"
          viewBox="0 0 100 100"
        >
          {/* Background Circle */}
          <circle
            cx="50"
            cy="50"
            r="45"
            stroke="#333"
            strokeWidth="10"
            fill="none"
          />
          {/* Progress Circle */}
          <circle
            cx="50"
            cy="50"
            r="45"
            stroke="#FF6B00"
            strokeWidth="10"
            fill="none"
            strokeDasharray="283"
            strokeDashoffset={283 - (percentage / 100) * 283}
            strokeLinecap="round"
            className="transition-all duration-500"
          />
        </svg>
        <span className="absolute text-lg font-bold">{percentage}%</span>
      </div>

      {/* Text Content */}
      <div className="flex-1">
        <h2 className="text-orange-500 text-lg md:text-xl font-semibold">
          {title}
        </h2>
        <p className="text-white text-sm md:text-base">{description}</p>
      </div>
    </div>
  ));
}
